import { useState } from 'react';

interface VoiceCallButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isGroup?: boolean;
}

/**
 * Voice/video call button component
 * - Works for both 1:1 and group calls
 * - Phone icon with hover state
 */
export const VoiceCallButton = ({ onClick, disabled = false }: VoiceCallButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (disabled || isLoading) return;

    setIsLoading(true);
    try {
      onClick();
    } finally {
      setIsLoading(false);
    }
  };

  const isDisabled = disabled || isLoading;

  return (
    <button
      onClick={handleClick}
      disabled={isDisabled}
      className={`p-2 rounded-full transition-colors ${
        isDisabled
          ? 'text-slate-300 cursor-not-allowed'
          : 'text-slate-600 hover:bg-slate-100 active:bg-slate-200'
      }`}
      title="Start call"
      aria-label="Start call"
    >
      {/* Phone Icon */}
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        />
      </svg>

      {/* Loading indicator */}
      {isLoading && (
        <div className="absolute inset-0 rounded-full animate-spin border-2 border-transparent border-t-blue-600" />
      )}
    </button>
  );
};
